import React, { memo, useMemo, useState, useEffect, useContext, useCallback } from 'react';
// import { H3 } from 'tea-component';
import { SortBy } from "tea-component/table/addons";
import TriggerViewCard from '@gp/components/TriggerViewCard';
// import SvgIcon from '@gp/components/Iconfont';
import MultipleLinesTextBubble from '@gp/components/MultipleLinesTextBubble';
import MergeableTable from './components/MergeableTable';
// import TableForPDFDownload from './components/MergeableTable/TableForPDFDownload';
// import LineEchartCon from './components/LineEchartCon';
import BarEchartCon from './components/BarEchartCon';
import { context as Context } from '@gp/components/Context';
import { isEqual } from 'lodash-es';
import GeneralDownloadBtn from '@gp/components/GeneralDownloadBtn';
import { studioOverallPeopleChartDownLoad } from '@gp/pages/StudioDashboard/StudioOverall/services/studioOverall';
import { FILE_TYPES2, FILE_TYPES_MAP } from '@gp/constants/const';
import useHeadcountsList from '@gp/pages/StudioDashboard/StudioOverall/Tabs/People/hooks/useHeadcountsList';
import { formatMonth } from '@gp/pages/StudioDashboard/StudioOverall/Tabs/People/utils/common';
// import useDownloadTablePDF from '../../hook/useDownloadTablePDF';
import useDownload, { createDownloadService } from '@gp/hooks/useDownload';
import { FIELDS1, FIELD_NAMES } from '@gp/utils/metricTips';
import './index.scss';

import SvgIcon from '@/pages/home/components/SvgIcon';
import CardBtn from '@/pages/globalpedia/components/CardBtn';

interface HeadcountsPropsType {
  loading: boolean;
  data: IStudioOverallPeopleChartResultItem;
  filterStartDate: string;
  filterEndDate: string;
  selectBO: string[];
  sortParamsRef: React.MutableRefObject<SortBy> | null;
  headcountCostRun: any;
}

// Headcount Cost模块名称
const MODULE_NAME = 'Headcount Cost';

// Headcount Cost模块 PDF下载 需要用到的className
// const PDF_DOWNLOAD_NODE_CLASSNAME =
//   'dbg-studio-overall-people-headcount-cost-pdf-card';

const DEFAULT_PROPS: HeadcountsPropsType = {
  loading: true,
  data: null,
  filterStartDate: '',
  filterEndDate: '',
  selectBO: [],
  sortParamsRef: null,
  headcountCostRun: null,
};

function Headcounts(props: HeadcountsPropsType) {
  const { loading, data, filterStartDate, filterEndDate, selectBO, sortParamsRef, headcountCostRun } = props;

  const [dataList, setDataList] = useState<orgHeadcountsDataTypes>(null);
  const [sorts, setSorts] = useState<SortBy>({
    by: '',
    order: undefined,
  });

  const { isDownloading, handleDownload } = useDownload({
    csvDownloadLogKey: 'STUDIO_OVERALL_PEOPLE_HEADCOUNT_COST_CSV_SUBMIT',
    excelDownloadLogKey: 'STUDIO_OVERALL_PEOPLE_HEADCOUNT_COST_EXCEL_SUBMIT',
    downloadService: createDownloadService(studioOverallPeopleChartDownLoad),
  });

  // 处理接口数据
  const { orgData } = useHeadcountsList({
    loading,
    responseRes: data,
  });

  /* const {
    isAllDatasResLoading,
    allDatas,
    updateAllDatas,
  } = useDownloadTablePDF(queryAllHeadcountCostOfPeople);

  const { isDownloading, setIsDownloading, handleDownload } = useDownload({
    fileName: MODULE_NAME,
    csvDownloadLogKey: 'STUDIO_OVERALL_DETAIL_PEOPLE_HEADCOUNT_COST_CSV_SUBMIT',
    pdfDownloadLogKey: 'STUDIO_OVERALL_DETAIL_PEOPLE_HEADCOUNT_COST_PDF_SUBMIT',
    node: document.querySelector(`.${PDF_DOWNLOAD_NODE_CLASSNAME}`),
    downloadService: createDownloadService(downloadHeadcountCostOfPeople),
  }); */

  // 接口返回数据
  useEffect(() => {
    if (loading) return;
    setDataList(orgData);
  }, [orgData, loading]);

  const handleSortsChange = useCallback((sorts: SortBy) => {
    setSorts(sorts);
    if (sortParamsRef?.current) sortParamsRef.current = sorts;
    headcountCostRun?.({
      start_date: filterStartDate,
      end_date: filterEndDate,
      management_team: selectBO,
      order_metric: formatMonth(sorts?.by),
      order: sorts?.order,
    });
  }, []);

  const tabs = useMemo(() => {
    return [
      {
        id: 'chart-bar',
        label: <CardBtn onClick={() => {}} type="column-chart" />,
        component: <BarEchartCon />,
      },
      /* {
        id: 'chart-line',
        label: (
          <label onClick={() => {}}>
            <SvgIcon type="chart-line" className="svgicon" />
          </label>
        ),
        component: <LineEchartCon />,
      }, */
      {
        id: 'table',
        label: <CardBtn onClick={() => {}} type="sheet" />,
        component: (
          <MergeableTable
            sorts={sorts}
            onSortsChange={handleSortsChange}
          />
        ),
      },
      {
        id: 'download',
        label: (
          <GeneralDownloadBtn
            uiType="2"
            fileTypes={FILE_TYPES2}
            isLoading={isDownloading}
            onConfirm={(payload) => {
              const fileType = payload?.fileType || FILE_TYPES_MAP.CSV;
              handleDownload({
                fileType,
                file_type: Number.parseInt(fileType, 10),
                start_date: filterStartDate || '',
                end_date: filterEndDate || '',
                management_team: selectBO || [],
                metrics: ['headcount_cost'], // headcount, headcount_cost, 5y_headcounts
                order_metric: formatMonth(sorts?.by),
                order: sorts?.order,
              });
            }}
          />
        ),
        component: null,
      },
    ];
  }, [sorts, isDownloading, filterStartDate, filterEndDate, selectBO, handleDownload]);

  /* const pdfTabs = useMemo(() => {
    return [
      {
        id: 'table',
        label: null,
        component: <TableForPDFDownload />,
      },
    ];
  }, []); */

  return (
    <Context.Provider
      value={{
        loading,
        dataList,
      }}
    >
      <div className="dbg-studio-overall-people-headcount-cost-card-container">
        <TriggerViewCard
          className="dbg-studio-overall-people-headcount-cost-content"
          title={
            <MultipleLinesTextBubble
              fields={FIELDS1}
              names={FIELD_NAMES}
              data={{
                definition: 'Total cost of in house full-time employee.',
                source: 'Studio Reporting Package',
                updateCadence: 'Monthly',
              }}
            >
              <span>{MODULE_NAME}</span>
            </MultipleLinesTextBubble>
          }
          loading={false}
          isNoData={false}
          tabs={tabs}
          defaultActiveId="chart-bar"
        />
        {/* <TriggerViewCard
          className="dbg-studio-overall-people-headcount-cost-content"
          // 这个rootNodeClassName 是为了 下载PDF用的 不要删除
          rootNodeClassName={PDF_DOWNLOAD_NODE_CLASSNAME}
          title={<H3 style={{ color: '#000', fontSize: 16 }}>{MODULE_NAME}</H3>}
          loading={false}
          isNoData={false}
          tabs={pdfTabs}
          defaultActiveId="table"
        /> */}
      </div>
    </Context.Provider>
  );
}

Headcounts.defaultProps = DEFAULT_PROPS;

export default memo(Headcounts, (prevProps: any, nextProps: any) => {
  return isEqual(prevProps, nextProps);
});
